import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton, Modal, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { gradientBackground } from '../../assets/styles/button.style';
import { useToastNotificationContext } from '../../hooks/global/alert/useToastNotification';

interface InstantMeetingModalProps {
  open: boolean;
  setClose: () => void;
}

const styles = {
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '12px',
    p: 4,
  },
  headerStyle: {
    fontFamily: 'Schibsted Grotesk',
    fontWeight: 500,
    fontSize: '18px',
  },
  bodyTextStyle: {
    fontFamily: 'Schibsted Grotesk',
    fontWeight: 500,
    fontSize: '14px',
  },
  textfieldStyle: {
    fontWeight: 400,
    fontSize: '16px',
    bgcolor: '#F6F6F6',
    borderRadius: '6px',
    padding: '8px 16px',
  },
  buttonStyle: {
    ...gradientBackground,
    borderRadius: '50px',
    fontSize: '16px',
    fontWeight: 500,
    marginTop: '12px',
  },
};



const JoinMeetingModal = ({ open, setClose }: InstantMeetingModalProps) => {
  const { createToastNotification } = useToastNotificationContext();
  const [link, setLink] = useState<string>('');

  const JoinMeetingHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!link) createToastNotification('No Link Entered', 'error');
    if (link.startsWith('http://') || link.startsWith('https://')) {
      window.open(`${link}`, '_blank');
    } else if (link.startsWith('/') || link.startsWith('meetings')) {
      window.open(`/${link}`, '_blank');
    } else {
      window.open(`/meetings/${link}`, '_blank');
    }
    // Open in a new tab
    event.preventDefault();
  };

  return (
    <Modal
      open={open}
      onClose={setClose}
      aria-labelledby="join-meeting-modal"
      aria-describedby="join-meeting-modal-description"
    >
      <Stack sx={styles.container} gap={3}>
        <Stack direction='row' justifyContent='space-between'>
          <Typography sx={styles.headerStyle}>
            <FormattedMessage 
              defaultMessage='Join a meeting seamlessly with just one click using the provided meet link'
            />
          </Typography>
          <IconButton sx={{ padding: '0px' }} onClick={setClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack 
          direction='column'
          gap={1}
        >
          <Typography sx={styles.bodyTextStyle}>
            <FormattedMessage 
              defaultMessage='Meeting link'
            />
          </Typography>
          <TextField
            variant='standard'
            InputProps={{ disableUnderline: true }}
            sx={styles.textfieldStyle}
            placeholder='meetings/bkk23lksd'
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </Stack>
        <Button 
          component="a"
          href=''
          sx={styles.buttonStyle} 
          disabled={!link}
          onClick={JoinMeetingHandler}
        >
          Join
        </Button>
      </Stack>
    </Modal>
  );
};

export default JoinMeetingModal;